import {DEFAULT_PROPERTY} from "@/Const";

let mProperty:any;
export function initProperty(db){
    mProperty = db.table('property');
    //判断是否有，没有的话就插入
    mProperty.get('createTime').then(res=>{
        if (!res){
            mProperty.bulkPut(DEFAULT_PROPERTY);
        }
    })
}

export async function initDefaultProperty(){
    //判断是否有，没有的话就插入
    mProperty.get('createTime').then(res=>{
        if (!res){
            mProperty.bulkPut(DEFAULT_PROPERTY);
        }
    })
}

export async function getPropertyById(id){
    return mProperty.get(id);
}

export async function getPropertyByIds(arrayIds){
    return mProperty.bulkGet(arrayIds);
}

export async function getPropertyList(){
    return  mProperty.toArray();
}

export async function getSortPropertyList(){
    const arrayProps = await getPropertyList();
    const arrayNewPropGroups:any = [];
    const arrayDefaultGroups = arrayProps.filter(p=>p.groupName == 'default');
    arrayDefaultGroups.sort((a,b)=>{
        return a.propertySort - b.propertySort;
    })
    arrayNewPropGroups.push(...arrayDefaultGroups);

    const arrayCustomGroups = arrayProps.filter(p=>p.groupName == 'custom');
    //拿出来default组，在前面.
    arrayCustomGroups.sort((a,b)=>{
        let sortA = a.propertySort,sortB = b.propertySort;
        if (sortA == undefined){
            sortA = a.createTime;
        }
        if (sortB == undefined){
            sortB = b.createTime;
        }
        return sortA - sortB;
    })
    arrayNewPropGroups.push(...arrayCustomGroups);
    return arrayNewPropGroups;
}

export function updateProperty(property){
    return mProperty.put(property);
}

export function deleteProperty(id){
    return mProperty.delete(id);
}

export function batchUpdateProperties(arrayProperties:any){
    return mProperty.bulkPut(arrayProperties);
}